import { Box, Button, Text } from '@bonanza-social/moonlight';
import { useTranslation } from '@bonanza-social/i18n';
import PromosBadgeList from '../PromosBadgeList/PromosBadgeList';
import PromoCta from '../PromoCta/PromoCta';
import { selectOptOutPending } from '../../state/promos/promos.slice';
import { useSelector } from '@bonanza-social/toolkit/state';
import { BottomSheet } from '@bonanza-social/navigation';
import { memo, useCallback } from 'react';
import { PromoSummaryProps } from './PromoSummary.types';
import { formatDate, SHORT_TIME } from '@bonanza-social/toolkit/utils';

function PromoSummary({ promo }: PromoSummaryProps) {
  const {
    promotionId,
    title,
    shortDescription,
    isOptedIn,
    rewards,
    status,
    promoType,
  } = promo;
  const isLoading = useSelector(selectOptOutPending(promotionId));
  const [t] = useTranslation('promos');

  const onOptOutClick = useCallback(() => {
    BottomSheet.open({
      namespace: 'promos',
      type: 'OptOutPromo',
      data: {
        promotionId,
      },
    });
  }, [promotionId]);

  return (
    <Box gap="space-200">
      <Text variant="h4" gradient="darkSurfaceAccent">
        {title}
      </Text>
      <PromosBadgeList rewards={rewards ?? []} />
      <Text variant="body-m-semi" color="darkSurfacePrimary">
        {shortDescription}
      </Text>
      <Box gap="space-300" marginTop="space-200" marginBottom="space-200">
        {status === 'Locked' ? null : <PromoCta promo={promo} />}
        {promoType !== 'Welcome' && isOptedIn ? (
          <Button
            variant="secondary"
            alignSelf="center"
            locNS="promos"
            locKey="optOut"
            onPress={onOptOutClick}
            loading={isLoading}
            width="100%"
          />
        ) : null}
        {promo.isOptedIn &&
        promo.promoType === 'Cashback' &&
        promo.optedInAt ? (
          <Box
            padding="space-300"
            borderRadius="radius-200"
            backgroundColor="secondaryBackgroundDefault"
          >
            <Text variant="body-s" color="darkSurfacePrimary">
              {t('cashbackOptedInAtMessage', {
                date: formatDate(promo.optedInAt),
                time: formatDate(promo.optedInAt, SHORT_TIME),
                interpolation: { escapeValue: false },
              })}
            </Text>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}

export default memo(PromoSummary);
